import { TFunction } from '@lyearn/i18n';
import {
  Browser,
  CenterBlock,
  Frame,
  FullBlock,
  Note,
  Slash,
  Smartphone,
  Square,
} from '@lyearn/icons';
import { PopoverOrigin } from '@lyearn/ui';

import { ImageLayoutTypes, MediaBlockLayoutTypes } from './types';

export const MEDIA_BLOCK_LAYOUTS = (t: TFunction) => [
  {
    label: t(`Lygo:${MediaBlockLayoutTypes.Center}`),
    type: MediaBlockLayoutTypes.Center,
    Icon: CenterBlock,
  },
  {
    label: t(`Lygo:${MediaBlockLayoutTypes.FullWidth}`),
    type: MediaBlockLayoutTypes.FullWidth,
    Icon: FullBlock,
  },
  { type: MediaBlockLayoutTypes.Break, label: t(`Lygo:${MediaBlockLayoutTypes.Break}`) },
  {
    label: t(`Lygo:${MediaBlockLayoutTypes.Frames}`),
    type: MediaBlockLayoutTypes.Frames,
    Icon: Frame,
  },
  // We're disabling the "Add Caption" option but it can be re-enabled by uncommenting the below code
  // { type: MediaBlockLayoutTypes.Break, label: t(`Lygo:${MediaBlockLayoutTypes.Break}`) },
  // {
  //   label: t(`Lygo:${MediaBlockLayoutTypes.AddCaption}`),
  //   type: MediaBlockLayoutTypes.AddCaption,
  //   Icon: Note,
  // },
];

export const MEDIA_BLOCK_POPOVER_OPTIONS = (t: TFunction) => {
  return {
    [MediaBlockLayoutTypes.Frames]: [
      {
        label: t(`Lygo:${ImageLayoutTypes.None}`),
        type: ImageLayoutTypes.None,
        Icon: Slash,
      },
      {
        label: t(`Lygo:${ImageLayoutTypes.Card}`),
        type: ImageLayoutTypes.Card,
        Icon: Square,
      },
      {
        label: t(`Lygo:${ImageLayoutTypes.Mobile}`),
        type: ImageLayoutTypes.Mobile,
        Icon: Smartphone,
      },
      {
        label: t(`Lygo:${ImageLayoutTypes.Web}`),
        type: ImageLayoutTypes.Web,
        Icon: Browser,
      },
    ],
  };
};

export const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};

export const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

export const CLASSES = {
  paper: 'rounded-8 shadow-01 border border-divider w-192 mt-8',
};
